import { captureException } from '@sentry/vue'

const STORAGE_KEY = 'curacel.auto_claims.support_query.tenant_token'

interface CachedTenantToken {
  userId: string
  token: string
  expiresAt: string
}

export function readCachedTenantToken(userId: string): CachedTenantToken | null {
  try {
    const value = window.localStorage.getItem(STORAGE_KEY)

    if (!value) {
      return null
    }

    const cached = JSON.parse(value) as Partial<CachedTenantToken>

    if (
      cached.userId !== userId ||
      typeof cached.token !== 'string' ||
      typeof cached.expiresAt !== 'string' ||
      Number.isNaN(Date.parse(cached.expiresAt))
    ) {
      return null
    }

    return cached as CachedTenantToken
  } catch (error) {
    captureException(error)
    return null
  }
}

export function writeCachedTenantToken(
  userId: string,
  token: string,
  expiresAt: string,
): void {
  try {
    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ userId, token, expiresAt }),
    )
  } catch (error) {
    captureException(error)
  }
}

export function clearCachedTenantToken(): void {
  try {
    window.localStorage.removeItem(STORAGE_KEY)
  } catch (error) {
    captureException(error)
  }
}

export function tokenNeedsRefresh(expiresAt: string, leadMs: number): boolean {
  const expiryTime = Date.parse(expiresAt)
  return Number.isNaN(expiryTime) || expiryTime - Date.now() <= leadMs
}
